/* Progressive enhancement only: Shopify receives every localization submission. */
class ToolLocalization extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.form?.addEventListener('submit', this.preserveReturnPath);
  }

  disconnectedCallback() {
    this.form?.removeEventListener('submit', this.preserveReturnPath);
  }

  preserveReturnPath = () => {
    // Preserve product variants, collection filters and the current page. Never
    // construct language prefixes or currency conversions in the browser.
    const field = this.form?.querySelector('input[name="return_to"]');
    if (field) field.value = window.location.pathname + window.location.search + window.location.hash;
  };
}

if (!customElements.get('tool-localization')) {
  customElements.define('tool-localization', ToolLocalization);
}
